import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import {map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppLauncherInfo } from '../../../store/appLauncher/appLauncher.model';

@Component({
  selector: 'app-new-search',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './new-search.component.html',
  styleUrl: './new-search.component.css'
})
export class NewSearchComponent {
  isPunchOut$: Observable<boolean>;
  constructor(
    private router: Router,
    private store: Store<{appLauncher: AppLauncherInfo}>
  ) {
    this.isPunchOut$ = this.store.select('appLauncher').pipe(
      map(appLauncherInfo => appLauncherInfo.isPunchOut)
    );
  }

  redirectToHome() {
    this.router.navigate(['/technician/home']);
  }

  redirectToLogin() {
    this.router.navigate(['/technician/login'])
  }

  redirectClick() {
    this.isPunchOut$.subscribe(value => {
      if (value) {
        this.redirectToLogin();
      }
      else {
        this.redirectToHome();
      }
    });
  }
}
